
import BundleProductAddToBundle from './bundle-product-add-to-bundle.vue'
import Select from '~/components/form/select/lole-select'
export default {
  components: { Select, BundleProductAddToBundle },
  inject: ['wording'],
  props: {
    colorChanged: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addedToBundle: false,
      selectedSize: null,
      wording: this.wording,
    }
  },
  watch: {
    product(newVal, oldVal) {
      if (newVal) {
        this.removeFromBundle()
      }
      // if (this.selectedSize) {
      //   const selectedSizeName = JSON.parse(this.selectedSize).name
      //   const sizeAvailable = newVal.sizes.filter(
      //     (size) => size.name === selectedSizeName && size.availability
      //   )

      //   console.log('DEBUG_WATCH_PRODUCT', sizeAvailable)

      //   if (sizeAvailable.length === 0) {
      //     this.removeFromBundle()
      //   } else {
      //     this.selectedSize = JSON.stringify(sizeAvailable[0])
      //   }
      // } else {
      //   this.removeFromBundle()
      // }
    },
  },
  // mounted() {
  //   if (
  //     this.product.sizes.length === 1 &&
  //     this.product.sizes[0].name === 'O/S'
  //   ) {
  //     this.selectedSize = JSON.stringify(this.product.sizes[0])
  //   }
  // },
  methods: {
    addToBundle() {
      this.addedToBundle = true
      this.$emit('sizeSelect', this.selectedSize)
    },
    removeFromBundle() {
      this.addedToBundle = false
      this.$emit('sizeSelect', null)
      this.clear()
    },
    clear() {
      this.$refs.sizeSelect.$el.children[0].selectedIndex = 0
      this.selectedSize = null
    },
  },
}
